module.exports = __webpack_public_path__ + "static/img/9127_phase_function_Paper_Points.395227f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9127_phase_function_Paper_Points.png
// module id = bQsK
// module chunks = 0